import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { Nullable } from '../constants/types';
import { USER_ROLE } from '../enum/role.enum';
import { UserInfo } from '../models/user-info.model';

@Directive({
  selector: '[appUserHasRole]',
})
export class UserHasRoleDirective implements OnInit {
  @Input('allowedRole') allowedRole: USER_ROLE = USER_ROLE.EMPLOYEE;
  constructor(
    private authService: AuthService,
    private elementRef: ElementRef,
  ) {}
  ngOnInit(): void {
    this.authService.getCurrentUser().subscribe((user: UserInfo) => {
      if (!user.hasAccess(this.allowedRole)) {
        this.elementRef.nativeElement.remove();
      }
    });
  }
}
